<template>
  <div slot="header" id="app">
    <vs-row>
      <vs-breadcrumb>
        <li aria-current="page" style="color: grey">Manage Work</li>
        <span class="vs-breadcrum--separator">/</span>

        <li aria-current="page" class="textSuccess">Parts</li>
      </vs-breadcrumb>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="space-around" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          actionable
          @click.native="TasksPopUp('Requested')"
          style="
            background: linear-gradient(45deg, #def1ff, #def1ff);
            border-radius: 15px;
          "
        >
          <vs-row>
            <!-- <h4 class="text-info font-weight-bold" style="font-weight: 400">
              Requested
            </h4> -->
            <h3 class="text-info">Requested</h3>
            <vs-spacer /><vs-spacer /><vs-spacer /><vs-icon
              icon="sync_alt"
              size="30px"
              color="#189AFA"
            ></vs-icon
          ></vs-row>
          <br />
          <br />
          <h1
            class="text-center text-info"
            style="font-size: 40px; font-weight: 500"
          >
            {{ rq }}
          </h1>
          <!-- <Pre>{{ this.OpenTasks }}</Pre> -->
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          actionable
          @click.native="TasksPopUp('Approve')"
          style="
            background: linear-gradient(45deg, #defde0, #defde0);
            border-radius: 15px;
          "
        >
          <vs-row>
            <h3 style="color: #32c040">Approve</h3>
            <vs-spacer /><vs-icon
              icon="done"
              size="30px"
              color="#32c040"
            ></vs-icon
          ></vs-row>
          <br />
          <br />
          <h1
            class="text-center"
            style="color: #32c040; font-size: 40px; font-weight: 500"
          >
            {{ ap }}
          </h1>
          <!-- <Pre>{{ this.OnGoing }}</Pre> -->
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          actionable
          @click.native="TasksPopUp('Reject')"
          style="
            background: linear-gradient(45deg, #ffeedb, #ffeedb);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h3 class="text-warning">Reject</h3>
            <vs-spacer /><vs-spacer /><vs-icon
              icon="close"
              size="30px"
              color="warning"
            ></vs-icon
          ></vs-row>
          <br />
          <br />
          <h1
            class="text-center text-warning"
            style="font-size: 40px; font-weight: 500"
          >
            {{ rj }}
          </h1>
          <!-- <Pre>{{ this.CompletedTasks }}</Pre> -->
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          actionable
          @click.native="TasksPopUp('Return')"
          style="
            background: linear-gradient(45deg, #ffdfdb, #ffdfdb);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h3 class="text-danger">Return</h3>
            <vs-spacer /><vs-icon
              icon="keyboard_return"
              size="30px"
              color="danger"
            ></vs-icon
          ></vs-row>
          <br />
          <br />
          <h1
            class="text-center text-danger"
            style="font-size: 40px; font-weight: 500"
          >
            {{ rt }}
          </h1>
        </vs-card>
      </vs-col>
    </vs-row>
    <div>
      <vs-card style="border-radius: 20px; width: 98%; margin-left: 1%">
        <template>
          <vs-col>
            <vs-row>
              <vs-icon icon="settings"></vs-icon>
              <h3>Parts</h3>
              <vs-spacer></vs-spacer>
              <!-- <vs-input
                icon="search"
                placeholder="Search"
                v-model="searchQuery"
              /> -->
            </vs-row>
            <vs-progress
              :height="2"
              :percent="100"
              color="primary"
              style="width: 12%"
              >primary</vs-progress
            >
            <br />
            <!-- {{ this.dessert }} -->
            <div class="mt-2 ml-2 filterContentHeader">
              <vs-row>
                <span class="mr-2 mt-2">Filter by :</span>
                <vs-select
                  placeholder="Part Information"
                  class="fontSizeData"
                  multiple
                  v-model="searchHeader"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in header2"
                  />
                </vs-select>

                <vs-spacer></vs-spacer>

                <vs-tooltip
                  text="This is a running total of how many Parts you have on stock and their cost"
                  position="top"
                >
                  <div class="mt-2 pt-1">
                    <span class="mr-2"
                      >{{ this.sumpart }} parts | ฿ {{ this.sumprice }}</span
                    >
                  </div>
                </vs-tooltip>
                <!-- <div>
                <vs-row> -->
                <!-- <btnBulkOrderPos />
                  <btnPartSetting /> -->

                <btnPDF
                  :dataList="this.dessert"
                  :headerName="'Part'"
                  :header="this.header2"
                />
                <btnExportXLSX
                  :dataList="this.dessert"
                  :headerName="'Part'"
                  :header="this.headers"
                />
                <vs-button
                  style="border-radius: 20px; height: 36px"
                  class="mr-2"
                  text-color="#111111"
                  color="rgba(9, 30, 66, 0.04)"
                  icon="settings"
                  id="show-btn"
                  v-b-modal.PartsLogs
                  @click="getpartlogs()"
                  >Request Parts
                </vs-button>
                <vs-tooltip
                  text="View all of your Parts logs in a combined format"
                >
                  <vs-button
                    style="border-radius: 20px; height: 36px"
                    text-color="#111111"
                    color="rgba(9, 30, 66, 0.04)"
                    icon="format_list_bulleted"
                    id="show-btn"
                    v-b-modal.PartsLogs
                    @click="getpartlogs()"
                    >Parts Logs
                  </vs-button>
                </vs-tooltip>

                <!-- <btnBulkActions /> -->
                <!-- <btnImportXLSX /> -->
                <!-- </vs-row>
              </div> -->
              </vs-row>
            </div>
            <vs-row>
              <div
                class="mt-2 fontSizeData"
                v-for="searchHeader in searchHeader"
                :key="searchHeader"
              >
                <div v-if="searchHeader == 'Name'">
                  <div class="textfill textSuccess"><span>Name</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterName"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Asset'">
                  <div class="textfill textSuccess"><span>Asset</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterAsset"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Category'">
                  <div class="textfill textSuccess"><span>Category</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterCategory"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Location'">
                  <div class="textfill textSuccess"><span>Location</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterLocation"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Open POs'">
                  <div class="textfill textSuccess"><span>Open POs</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterPOs"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Part Name'">
                  <div class="textfill textSuccess"><span>Part Name</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterPartName"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Part Number'">
                  <div class="textfill textSuccess">
                    <span>Part number</span>
                  </div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterPartNumber"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Price'">
                  <div class="textfill textSuccess"><span>Price</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterPrice"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Qty'">
                  <div class="textfill textSuccess"><span>Qty</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterQty"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
                <div v-if="searchHeader == 'Vendor'">
                  <div class="textfill textSuccess"><span>Vendor</span></div>
                  <div class="contentitem">
                    <vs-input
                      class="inputx"
                      placeholder="Search Name"
                      v-model="selectFilterVendor"
                    />
                    <vs-icon
                      class="clearIcon"
                      size="0.9rem"
                      color="light"
                      @click="remove(searchHeader)"
                      icon="close"
                    ></vs-icon>
                  </div>
                </div>
              </div>
            </vs-row>
            <vs-progress :height="1" :percent="100" color="primary"
              >primary</vs-progress
            >
            <br />
            <br />
            <vs-row>
              <btnAddPart :location="this.locationList" /><btnAddStock
                :desserts="this.dessert"
                :location="this.locationList"
              />
              <vs-spacer></vs-spacer>
              <vs-tooltip text="Edit Visible Columns" position="top">
                <vs-dropdown vs-trigger-click v-if="colbtn == true">
                  <vs-button
                    class="btn-drop"
                    type="filled"
                    icon="view_week"
                    style="border-radius: 20px"
                  ></vs-button>

                  <vs-dropdown-menu style="width: 20%">
                    <h5 class="ml-2 mt-2">Columns:</h5>
                    <vs-divider></vs-divider>
                    <vs-checkbox
                      class="mt-1 pb-1 ml-4"
                      :disabled="visibleFields.length == 1 && header.visible"
                      v-for="header in headers"
                      :key="header.key"
                      style="justify-content: start"
                      v-model="header.visible"
                    >
                      {{ header.id }}
                    </vs-checkbox>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-tooltip>
            </vs-row>
            <br />
          </vs-col>
        </template>

        <vs-tabs alignment="right" color="#555555">
          <vs-tab icon="settings" label="Card" @click="colbtn = false">
            <vs-card
              style="width: 100%; border-radius: 20px"
              v-for="item in Fileter"
              :key="item"
            >
              <header slot="header" style="height: auto">
                <vs-row>
                  <h3>{{ item.name }}</h3>
                  <vs-spacer></vs-spacer>
                  <vs-tooltip
                    text="Look up this part by QR code"
                    position="bottom"
                  >
                    <vs-button
                      radius
                      class="mr-2"
                      color="#333f50"
                      type="flat"
                      icon="dashboard"
                      @click="QrCode(item)"
                    >
                    </vs-button>
                  </vs-tooltip>
                  <vs-tooltip text="Settings" position="bottom">
                    <vs-dropdown vs-trigger-click>
                      <vs-button
                        radius
                        color="#333f50"
                        type="flat"
                        icon="settings"
                      ></vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="EditPart(item)">
                          <span>Edit</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item
                          ><span @click="DeletePart(item)">Delete</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </vs-tooltip>
                </vs-row>
              </header>
              <vs-row>
                <div class="centerx">
                  <vs-upload />
                </div>
                <div class="mt-4 ml-5 pl-5" style="width: 50%">
                  <vs-row>
                    <vs-icon icon="help" class="mr-2" size="15px"></vs-icon>
                    <p>information</p>
                    <!-- <p @click="PartviewCard(item)">information</p> -->
                  </vs-row>
                  <vs-divider></vs-divider>
                  <!-- {{ item.id }} -->
                  <p>Part Number : {{ item.partnumber }}</p>
                  <p>Part Price : ฿ {{ item.price }}</p>
                  <p>Part Location : {{ item.location_name }}</p>
                  <p>Qty : {{ item.qtycurrent }}</p>
                </div>
              </vs-row>
              <vs-divider></vs-divider>
              <vs-tabs>
                <vs-tab label="Detail">
                  <div class="ml-3 mr-3">
                    <vs-row>
                      <h3 class="mt-4">
                        <p><b style="color: #60ce6a">Detail</b></p>
                      </h3>
                      <vs-spacer></vs-spacer>
                      <btnExportXLSX class="mt-4" />
                    </vs-row>
                    <vs-row>
                      <vs-icon
                        icon="help"
                        class="mr-2 mt-2 pt-1"
                        size="15px"
                      ></vs-icon>
                      <h6 class="mt-2 pt-1 mb-4">
                        <b>Information -</b> Track any piece of information for
                        your parts including names, numbers, quantities, price,
                        location and more.
                      </h6>
                    </vs-row>
                    <br />
                    <br />
                    <vs-row>
                      <vs-icon icon="person" size="small"></vs-icon>
                      <p class="ml-3 mt-1">
                        <b>Part Name :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                          item.partname
                        }}
                      </p>
                    </vs-row>
                    <vs-divider></vs-divider>
                    <vs-row>
                      <vs-icon icon="dashboard" size="small"></vs-icon>
                      <p class="ml-3 mt-1">
                        <b>Part Number :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                          item.partnumber
                        }}
                      </p>
                    </vs-row>
                    <vs-divider></vs-divider>

                    <vs-row>
                      <vs-icon class="ml-1"><b>#</b></vs-icon>
                      <p class="mt-2 ml-4">
                        <b>Qty :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                          item.qtycurrent
                        }}
                      </p>
                      <p class="mt-2 ml-5">
                        <b>Unit :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.unit }}
                      </p>
                    </vs-row>

                    <vs-divider></vs-divider>
                    <vs-row>
                      <vs-icon icon="location_on" size="small"></vs-icon>
                      <p class="ml-3 mt-1">
                        <b>Part Location : </b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                          item.location_name
                        }}
                      </p>
                    </vs-row>
                    <vs-divider></vs-divider>
                    <vs-row>
                      <vs-icon icon="attach_money" size="small"></vs-icon>
                      <p class="ml-3 mt-1">
                        <b>Price :</b>&nbsp;&nbsp;&nbsp;&nbsp;฿ {{ item.price }}
                      </p>
                    </vs-row>
                    <vs-divider></vs-divider>
                  </div>
                </vs-tab>
                <vs-tab label="Work Order" @click="getWOList(item.id)">
                  <div class="ml-3 mr-3">
                    <vs-row>
                      <h3 class="mt-4">
                        <p><b style="color: #60ce6a">Work Order</b></p>
                      </h3>
                      <vs-spacer></vs-spacer>
                      <btnExportXLSX
                        class="mt-4"
                        :dataList="workorders"
                        :headerName="'WorkOrder'"
                        :header="workhead"
                      />
                    </vs-row>

                    <!-- <b-table
                      :items="workorders"
                      :fields="workhead"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      sort-icon-left
                      responsive="sm"
                      borderless
                      hover
                      search
                    ></b-table> -->
                    <vs-card
                      v-for="(item, index) in workorders"
                      @click.native="WorkOrderdetail"
                      :key="index"
                      style="margin-bottom: 0"
                      actionable
                    >
                      <h2 class="mt-1 ml-1">
                        <b>{{ item.name }}</b>
                      </h2>
                      <br />
                      <vs-row>
                        <p class="ml-2 mt-1" style="color: gray">
                          Created : {{ item.startdate }}
                        </p>
                        <vs-spacer></vs-spacer>
                        <div>
                          <vs-icon
                            v-if="item.status == 'Opened'"
                            icon="lock_open"
                            size="large"
                            color="gray"
                            class="mr-3"
                          ></vs-icon>
                          <vs-icon
                            v-if="item.status == 'Closed'"
                            icon="lock"
                            color="success"
                            size="large"
                            class="mr-1"
                          ></vs-icon>
                        </div>
                        <h4 class="mt-3 mr-2">
                          <b v-if="item.status == 'open'" style="color: gray">
                            Open
                          </b>
                        </h4>
                        <h4 class="mt-3 mr-4">
                          <b v-if="item.status == 'close'" style="color: green">
                            Closed
                          </b>
                        </h4>
                      </vs-row>
                      <p class="ml-2" style="color: gray">
                        Last Updated : {{ item.editdate }}
                      </p>
                    </vs-card>
                  </div>
                </vs-tab>
                <vs-tab label="Asset">
                  <div class="ml-4 mr-4">
                    <vs-row>
                      <h3 class="mt-4">
                        <p><b style="color: #60ce6a">Asset</b></p>
                      </h3>
                      <vs-spacer></vs-spacer>
                      <btnExportXLSX class="mt-4" />
                    </vs-row>
                    <br />
                    <vs-card
                      v-for="asset in item.asset"
                      :key="asset"
                      style="margin-bottom: 1%"
                    >
                      <vs-row>
                        <vs-icon
                          icon="inventory"
                          size="small"
                          class="mt-2 ml-3"
                        ></vs-icon>
                        <span
                          v-b-modal.partDetail
                          class="underline-on-hover mt-2 pt-1 ml-3"
                          style="color: #32c040"
                        >
                          {{ asset }}
                        </span>
                        <vs-spacer></vs-spacer>
                        <vs-button
                          color="#FC3939"
                          icon="delete"
                          type="flat"
                          class="ml-2"
                          style="border-radius: 20px"
                          @click="deleteRow(index)"
                        >
                        </vs-button>
                      </vs-row>
                    </vs-card>
                  </div>
                </vs-tab>
                <vs-tab label="Event">
                  <div class="ml-3 mr-3">
                    <vs-row>
                      <h3 class="mt-4">
                        <p><b style="color: #60ce6a">Event</b></p>
                      </h3>
                      <vs-spacer></vs-spacer>
                      <btnExportXLSX
                        class="mt-4"
                        :dataList="workorders"
                        :headerName="'Event'"
                        :header="workhead"
                      />
                    </vs-row>
                    <b-table
                      :items="workorders"
                      :fields="workhead"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      sort-icon-left
                      responsive="sm"
                      borderless
                      hover
                    ></b-table>
                  </div>
                </vs-tab>
                <vs-tab label="Vendor">
                  <div class="con-tab-ejemplo">
                    <div class="ml-4 mr-4">
                      <vs-row>
                        <h3 class="mt-4">
                          <p><b style="color: #60ce6a">Vendor</b></p>
                        </h3>
                        <vs-spacer></vs-spacer>
                        <btnExportXLSX class="mt-4" />
                      </vs-row>
                      <br />
                      <vs-card style="margin-bottom: 1%">
                        <vs-row>
                          <vs-icon
                            icon="badge"
                            size="small"
                            class="mt-2 ml-3"
                          ></vs-icon>
                          <span
                            v-b-modal.PartDetail
                            class="underline-on-hover mt-2 pt-1 ml-3"
                            style="color: #32c040"
                          >
                            {{ item.vendor }}
                          </span>
                          <vs-spacer></vs-spacer>
                          <vs-button
                            color="#FC3939"
                            icon="delete"
                            type="flat"
                            class="ml-2"
                            style="border-radius: 20px"
                            @click="deleteRow(index)"
                          >
                          </vs-button>
                        </vs-row>
                      </vs-card>
                    </div>
                  </div>
                </vs-tab>

                <vs-tab label="Report">
                  <!-- <vs-button @click="ExportPDF">Export PDF</vs-button> -->
                  <div class="con-tab-ejemplo" ref="printcontent" id="content">
                    <div class="ml-4 mr-4">
                      <vs-row>
                        <h3 class="mt-4">
                          <p><b style="color: #60ce6a">Report</b></p>
                        </h3>
                        <vs-spacer></vs-spacer>
                        <vs-tooltip text="Export PDF" position="top">
                          <vs-button
                            radius
                            class="mr-2 mt-4"
                            color="#333f50"
                            type="flat"
                            @click="ExportPDF()"
                            icon="picture_as_pdf"
                          ></vs-button
                        ></vs-tooltip>
                        <!-- <btnExportXLSX class="mt-4" @click="ExportPDF" /> -->
                      </vs-row>
                      <vs-row>
                        <vs-icon
                          icon="equalizer"
                          class="mr-2 mt-2 pt-1"
                          size="15px"
                        ></vs-icon>
                        <h6 class="mt-2 pt-1 mb-4">
                          <b>Reports -</b> Important statistics for only this
                          part. -
                          {{ item.name }}
                        </h6>
                      </vs-row>
                      <vs-row vs-justify="center" class="mt-3">
                        <vs-col
                          type="flex"
                          vs-justify="center"
                          vs-align="center"
                          vs-w="6"
                        >
                          <vs-card
                            actionable
                            class="cardx"
                            style="
                              background: #edfceb;
                              border-radius: 15px;
                              text-align: center;
                            "
                          >
                            <div>
                              <h1 style="color: #60ce6a"><b>5</b></h1>
                              <p class="mb-4">Total Parts Used</p>

                              <h1 style="color: #ff7575"><b>Disabled</b></h1>
                              <p>Stale Status</p>
                            </div>
                          </vs-card>
                        </vs-col>
                        <vs-col
                          type="flex"
                          vs-justify="center"
                          vs-align="center"
                          vs-w="6"
                        >
                          <vs-card
                            actionable
                            class="cardx"
                            style="
                              background: #edfceb;
                              border-radius: 15px;
                              text-align: center;
                            "
                          >
                            <div>
                              <h1 style="color: #60ce6a"><b>฿0.00</b></h1>
                              <p class="mb-4">Total Cost</p>

                              <h1 style="color: #60ce6a"><b>86</b></h1>
                              <p>Days Since Last Used</p>
                            </div>
                          </vs-card>
                        </vs-col>
                      </vs-row>
                      <vs-tabs alignment="center">
                        <vs-tab label="Forecast">
                          <div class="mt-2 pt-1 mb-4">
                            <b>Forecast -</b> Below is the estimated use of this
                            part for the next year
                          </div>
                          <div>
                            <Chart />
                          </div>
                        </vs-tab>
                        <vs-tab label="Recent Usage">
                          <div class="mt-2 pt-1 mb-4">
                            <b>Recent Usage -</b> View where this Part has been
                            recently used
                          </div>
                          <b-table
                            :items="ReportList"
                            :fields="ReportHead"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            sort-icon-left
                            responsive="sm"
                            borderless
                            hover
                          ></b-table>
                        </vs-tab>
                      </vs-tabs>
                    </div>
                  </div>
                </vs-tab>
              </vs-tabs>
            </vs-card>
          </vs-tab>
          <vs-tab
            icon="format_list_bulleted"
            label="List"
            @click="colbtn = true"
          >
            <div>
              <br />
              <b-table
                :items="Fileter"
                :fields="visibleFields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                sort-icon-left
                responsive="sm"
                borderless
                filter-included-fields=""
                hover
              >
                <template #cell(Actions)="item">
                  <vs-row>
                    <vs-button
                      color="primary"
                      type="flat"
                      icon="add_circle"
                      @click="Partview(item)"
                      >View</vs-button
                    >
                    <vs-button
                      color="warning"
                      type="flat"
                      icon="create"
                      @click="EditPart(item.item)"
                      >Edit</vs-button
                    >
                    <vs-button
                      color="danger"
                      type="flat"
                      icon="delete"
                      @click="DeletePart(item.item)"
                      >Delete</vs-button
                    >
                  </vs-row>
                </template>
              </b-table>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </div>

    <b-modal id="PartsLogs" centered hide-footer size="lg">
      <template #modal-title>
        <h3>All Parts Logs</h3>
      </template>
      <div><Table :desserts="WRParts" :header="logsheader" /></div>
    </b-modal>

    <b-modal id="EditPart" centered size="lg" scrollable="true">
      <template #modal-title>
        <h3>Edit</h3>
        <!-- <Pre>{{locationList}}</Pre> -->
      </template>
      <template>
        <vs-row vs-w="12" class="pr-5">
          <vs-col
            vs-type="flex"
            vs-justify="end"
            vs-align="center"
            vs-lg="6"
            vs-sm="4"
            vs-xs="12"
            style="text-align: end"
          >
            PartName&nbsp;&nbsp;&nbsp;:
            <br />
            <br />
            <br />
            Category&nbsp;&nbsp;&nbsp;:
            <br />
            <br />
            <br />
            Price&nbsp;&nbsp;&nbsp;:
            <br />
            <br />
            <br />
            Qty&nbsp;&nbsp;&nbsp;:
            <br />
            <br />
            <br />
            Part Number&nbsp;&nbsp;&nbsp;:
            <br />
            <br />
            <br />
            Location&nbsp;&nbsp;&nbsp;:
            <br />
            <br />
            <br />
            Vendor&nbsp;&nbsp;&nbsp;:
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-lg="6"
            vs-sm="4"
            vs-xs="12"
          >
            <div>
              <vs-input
                color="success"
                v-model="viewerdata1.partname"
                style="width: 100%; padding-bottom: 1%"
                :danger="this.dangerName"
                :danger-text="this.dangerNametext"
                @change="nameValidate(viewerdata1.partname)"
              />
              <br />
              <vs-input
                color="success"
                v-model="viewerdata1.category"
                style="width: 100%; padding-bottom: 1%"
                :danger="this.dangerCate"
                :danger-text="this.dangerCatetext"
                @change="cateValidate(viewerdata1.category)"
              /><br />
              <vs-input
                color="success"
                v-model="viewerdata1.price"
                style="width: 100%; padding-bottom: 1%"
                type="number"
                min="0"
              /><br />
              <div>
                <vs-input-number
                  color="success"
                  v-model="viewerdata1.qtycurrent"
                  min="0"
                />
              </div>
              <br />
              <vs-input
                color="success"
                v-model="viewerdata1.partnumber"
                style="width: 100%; padding-bottom: 1%"
                type="number"
                min="0"
                :danger="this.dangerNumber"
                :danger-text="this.dangerNumbertext"
                @change="numberValidate(viewerdata1.partnumber)"
              /><br />
              <vs-select
                placeholder="Select Location"
                v-model="viewerdata1.location_name"
                style="width: 100%"
                ><br />
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.list.value"
                  v-for="(item, index) in locationList"
                />
              </vs-select>
              <br />
              <vs-select
                placeholder="Select Vendor"
                v-model="viewerdata1.vendor"
                style="width: 100%"
                ><br />
                <vs-select-item
                  :key="index"
                  :value="item.Name"
                  :text="item.Name"
                  v-for="(item, index) in Vendor"
                />
              </vs-select>
            </div>
          </vs-col>
        </vs-row>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('EditPart')"
          >
            Cancle
          </b-button>
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 10%"
            class="ml-2"
            @click="EdiPartData()"
            >Submit</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="PartDetail" centered size="lg" scrollable="true" :item="item">
      <template #modal-title>
        <h3>Part Viewer</h3>
      </template>
      <template>
        <div style="width: 100%; border-radius: 20px">
          <header slot="header" style="height: auto">
            <vs-row>
              <h3>{{ viewerdata.name }}</h3>
              <vs-spacer></vs-spacer>
              <vs-tooltip text="Look up this part by QR code" position="bottom">
                <vs-button
                  radius
                  class="mr-2"
                  color="#333f50"
                  type="flat"
                  icon="dashboard"
                  v-b-modal.QrCode
                >
                </vs-button>
              </vs-tooltip>
              <vs-tooltip text="Settings" position="bottom">
                <vs-dropdown vs-trigger-click>
                  <vs-button
                    radius
                    color="#333f50"
                    type="flat"
                    icon="settings"
                  ></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item>
                      <span v-b-modal.EditPart>Edit</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      ><span v-b-modal.DeletePart>Delete</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-tooltip>
            </vs-row>
          </header>
          <vs-row>
            <div class="centerx">
              <vs-upload />
            </div>
            <div class="mt-4 ml-5 pl-5" style="width: 50%">
              <vs-row>
                <vs-icon icon="help" class="mr-2" size="15px"></vs-icon>
                <p>information</p>
              </vs-row>
              <vs-divider></vs-divider>
              <p>Part Number : {{ viewerdata.partnumber }}</p>
              <p>Part Price : ฿ {{ viewerdata.price }}</p>
              <p>Part Location :{{ viewerdata.location_name }}</p>
              <p>Qty : {{ viewerdata.qtycurrent }}</p>
            </div>
          </vs-row>
          <vs-divider></vs-divider>
          <vs-tabs>
            <vs-tab label="Detail">
              <div class="ml-3 mr-3">
                <vs-row>
                  <h3 class="mt-4">
                    <p><b style="color: #60ce6a">Detail</b></p>
                  </h3>
                  <vs-spacer></vs-spacer>
                  <btnExportXLSX class="mt-4" />
                </vs-row>
                <vs-row>
                  <vs-icon
                    icon="help"
                    class="mr-2 mt-2 pt-1"
                    size="15px"
                  ></vs-icon>
                  <h6 class="mt-2 pt-1 mb-4">
                    <b>Information -</b> Track any piece of information for your
                    parts including names, numbers, quantities, price, location
                    and more.
                  </h6>
                </vs-row>
                <br />
                <br />
                <vs-row>
                  <vs-icon icon="person" size="small"></vs-icon>
                  <p class="ml-3 mt-1">
                    <b>Part Name :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                      viewerdata.partname
                    }}
                  </p>
                </vs-row>
                <vs-divider></vs-divider>
                <vs-row>
                  <vs-icon icon="dashboard" size="small"></vs-icon>
                  <p class="ml-3 mt-1">
                    <b>Part Number :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                      viewerdata.partnumber
                    }}
                  </p>
                </vs-row>
                <vs-divider></vs-divider>

                <vs-row>
                  <vs-icon class="ml-1"><b>#</b></vs-icon>
                  <p class="mt-2 ml-4">
                    <b>Qty :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                      viewerdata.qtycurrent
                    }}
                  </p>
                  <p class="mt-2 ml-5">
                    <b>Unit :</b>&nbsp;&nbsp;&nbsp;&nbsp;{{ viewerdata.unit }}
                  </p>
                </vs-row>

                <vs-divider></vs-divider>
                <vs-row>
                  <vs-icon icon="location_on" size="small"></vs-icon>
                  <p class="ml-3 mt-1">
                    <b>Part Location : </b>&nbsp;&nbsp;&nbsp;&nbsp;{{
                      viewerdata.location_name
                    }}
                  </p>
                </vs-row>
                <vs-divider></vs-divider>
                <vs-row>
                  <vs-icon icon="attach_money" size="small"></vs-icon>
                  <p class="ml-3 mt-1">
                    <b>Price :</b>&nbsp;&nbsp;&nbsp;&nbsp;฿
                    {{ viewerdata.price }}
                  </p>
                </vs-row>
                <vs-divider></vs-divider>
              </div>
            </vs-tab>
            <vs-tab label="Work Order">
              <div class="ml-3 mr-3">
                <vs-row>
                  <h3 class="mt-4">
                    <p><b style="color: #60ce6a">Work Order</b></p>
                  </h3>
                  <vs-spacer></vs-spacer>
                  <btnExportXLSX class="mt-4" />
                </vs-row>
                <b-table
                  :items="workorders"
                  :fields="workhead"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  responsive="sm"
                  borderless
                  hover
                ></b-table>
              </div>
            </vs-tab>
            <vs-tab label="Asset">
              <div class="ml-4 mr-4">
                <vs-row>
                  <h3 class="mt-4">
                    <p><b style="color: #60ce6a">Asset</b></p>
                  </h3>
                  <vs-spacer></vs-spacer>
                  <btnExportXLSX class="mt-4" />
                </vs-row>
                <br />
                <vs-card
                  v-for="asset in viewerdata.asset"
                  :key="asset"
                  style="margin-bottom: 1%"
                >
                  <vs-row>
                    <vs-icon
                      icon="inventory"
                      size="small"
                      class="mt-2 ml-3"
                    ></vs-icon>
                    <span
                      v-b-modal.partDetail
                      class="underline-on-hover mt-2 pt-1 ml-3"
                      style="color: #32c040"
                    >
                      {{ asset }}
                    </span>
                    <vs-spacer></vs-spacer>
                    <vs-button
                      color="#FC3939"
                      icon="delete"
                      type="flat"
                      class="ml-2"
                      style="border-radius: 20px"
                      @click="deleteRow(index)"
                    >
                    </vs-button>
                  </vs-row>
                </vs-card>
              </div>
            </vs-tab>
            <vs-tab label="Event">
              <div class="ml-3 mr-3">
                <vs-row>
                  <h3 class="mt-4">
                    <p><b style="color: #60ce6a">Event</b></p>
                  </h3>
                  <vs-spacer></vs-spacer>
                  <btnExportXLSX class="mt-4" />
                </vs-row>
                <b-table
                  :items="workorders"
                  :fields="workhead"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  responsive="sm"
                  borderless
                  hover
                ></b-table>
              </div>
            </vs-tab>
            <vs-tab label="Vendor">
              <div class="con-tab-ejemplo">
                <div class="ml-4 mr-4">
                  <vs-row>
                    <h3 class="mt-4">
                      <p><b style="color: #60ce6a">Vendor</b></p>
                    </h3>
                    <vs-spacer></vs-spacer>
                    <btnExportXLSX class="mt-4" />
                  </vs-row>
                  <br />
                  <vs-card style="margin-bottom: 1%">
                    <vs-row>
                      <vs-icon
                        icon="badge"
                        size="small"
                        class="mt-2 ml-3"
                      ></vs-icon>
                      <span
                        v-b-modal.PartDetail
                        class="underline-on-hover mt-2 pt-1 ml-3"
                        style="color: #32c040"
                      >
                        {{ viewerdata.vendor }}
                      </span>
                      <vs-spacer></vs-spacer>
                      <vs-button
                        color="#FC3939"
                        icon="delete"
                        type="flat"
                        class="ml-2"
                        style="border-radius: 20px"
                        @click="deleteRow(index)"
                      >
                      </vs-button>
                    </vs-row>
                  </vs-card>
                </div>
              </div>
            </vs-tab>

            <vs-tab label="Report">
              <div class="con-tab-ejemplo">
                <div class="ml-4 mr-4">
                  <vs-row>
                    <h3 class="mt-4">
                      <p><b style="color: #60ce6a">Report</b></p>
                    </h3>
                    <vs-spacer></vs-spacer>
                    <btnExportXLSX class="mt-4" />
                  </vs-row>
                  <vs-row>
                    <vs-icon
                      icon="equalizer"
                      class="mr-2 mt-2 pt-1"
                      size="15px"
                    ></vs-icon>
                    <h6 class="mt-2 pt-1 mb-4">
                      <b>Reports -</b> Important statistics for only this part.
                      -
                      {{ viewerdata.name }}
                    </h6>
                  </vs-row>
                  <vs-row vs-justify="center" class="mt-3">
                    <vs-col
                      type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="6"
                    >
                      <vs-card
                        actionable
                        class="cardx"
                        style="
                          background: #edfceb;
                          border-radius: 15px;
                          text-align: center;
                        "
                      >
                        <div>
                          <h1 style="color: #60ce6a"><b>5</b></h1>
                          <p class="mb-4">Total Parts Used</p>

                          <h1 style="color: #ff7575"><b>Disabled</b></h1>
                          <p>Stale Status</p>
                        </div>
                      </vs-card>
                    </vs-col>
                    <vs-col
                      type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="6"
                    >
                      <vs-card
                        actionable
                        class="cardx"
                        style="
                          background: #edfceb;
                          border-radius: 15px;
                          text-align: center;
                        "
                      >
                        <div>
                          <h1 style="color: #60ce6a"><b>฿0.00</b></h1>
                          <p class="mb-4">Total Cost</p>

                          <h1 style="color: #60ce6a"><b>86</b></h1>
                          <p>Days Since Last Used</p>
                        </div>
                      </vs-card>
                    </vs-col>
                  </vs-row>
                  <vs-tabs alignment="center">
                    <vs-tab label="Forecast">
                      <div class="mt-2 pt-1 mb-4">
                        <b>Forecast -</b> Below is the estimated use of this
                        part for the next year
                      </div>
                      <div>
                        <ChartPart />
                      </div>
                    </vs-tab>
                    <vs-tab label="Recent Usage">
                      <div class="mt-2 pt-1 mb-4">
                        <b>Recent Usage -</b> View where this Part has been
                        recently used
                      </div>
                      <b-table
                        :items="ReportList"
                        :fields="ReportHead"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        sort-icon-left
                        responsive="sm"
                        borderless
                        hover
                      ></b-table>
                    </vs-tab>
                  </vs-tabs>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('PartDetail')"
            class="ml-2"
            >Done</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="DeletePart" centered size="lg" scrollable="true">
      <template #modal-title>
        <h3>Delete Part</h3>
      </template>
      <p style="text-align: center">
        Are you sure you want to delete this part?
      </p>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('DeletePart')"
          >
            Cancle
          </b-button>
          <vs-button
            type="filled"
            color="#FC3939"
            style="border-radius: 20px; width: 10%"
            class="ml-2"
            @click="Delete(viewerdata)"
            >Delete</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="QrCode" centered size="lg" scrollable="true">
      <template #modal-title>
        <h3>Part QR Codes</h3>
      </template>

      <template>
        <p style="text-align: start">
          Use the QR Codes to lookup a part which allows you to update its
          quantity.
        </p>
        <vs-divider></vs-divider>
        <h1 style="text-align: center">Part name</h1>
        <vs-row>
          <vs-spacer></vs-spacer>
          <vs-icon icon="dashboard" size="300px"></vs-icon>
          <div class="mt-5">
            <p>PartName : {{ viewerdata.partname }}</p>
            <p>Part Number : {{ viewerdata.partnumber }}</p>
            <p>Location : {{ viewerdata.location }}</p>
            <vs-row>
              <p>Assets :</p>
              <p v-for="item in viewerdata.asset" :key="item">
                &nbsp;{{ item }} ,
              </p>
            </vs-row>

            <!-- <p >Assets : {{ viewerdata.asset }}</p> -->
            <p>Vendors : {{ viewerdata.vendor }}</p>
          </div>
          <vs-spacer></vs-spacer>
        </vs-row>
        <vs-row>
          <vs-spacer></vs-spacer>
          <vs-button
            style="border-radius: 20px"
            color="#E6E7E8"
            class="mr-2"
            icon="file_download"
            text-color="#111111"
            >Download URLs/Info</vs-button
          >
          <vs-button
            style="border-radius: 20px"
            color="#E6E7E8"
            class="mr-2"
            icon="file_download"
            text-color="#111111"
            >Download Images</vs-button
          >
          <vs-button style="border-radius: 20px" class="mr-2" icon="print"
            >Print Options</vs-button
          >
          <vs-spacer></vs-spacer>
        </vs-row>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('QrCode')"
          >
            Close
          </b-button>
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="PartLogs" centered size="lg" scrollable="true">
      <!-- {{ this.OpenTasks }}
      {{ this.CompletedTasks }}
      {{ this.OnGoing }} -->
      <!-- {{ this.logsheader }} -->
      <template #modal-title>
        <h3 v-if="tasksstatus === 1">Requested</h3>
        <h3 v-if="tasksstatus === 2">Approve</h3>
        <h3 v-if="tasksstatus === 3">Reject</h3>
        <h3 v-if="tasksstatus === 4">Return</h3>
      </template>
      <Table
        :desserts="this.Requested"
        :header="logsheader"
        v-if="this.tasksstatus === 1"
      />
      <Table
        :desserts="this.Approve"
        :header="logsheader"
        v-if="this.tasksstatus === 2"
      />
      <Table
        :desserts="this.Reject"
        :header="logsheader"
        v-if="this.tasksstatus === 3"
      />
      <Table
        :desserts="this.Return"
        :header="logsheader"
        v-if="this.tasksstatus === 4"
      />
    </b-modal>
  </div>
</template>
<script>
import btnPDF from "../Page/Button/btnPDF.vue";
import btnExportXLSX from "../Page/Button/btnExportXLSX.vue";
import btnImportXLSX from "../Page/Button/btnImportXLSX.vue";
import btnBulkActions from "../Page/Button/btnBulkActions.vue";
import btnPartSetting from "../Page/Button/btnPartSetting.vue";
import btnBulkOrderPos from "../Page/Button/btnBulkOrderPos.vue";
import btnAddPart from "../Page/Button/btnAddPart.vue";
import btnAddStock from "../Page/Button/btnAddStock.vue";
import Chart from "../dashboard/Part&Inventory/Chart.vue";
import Table from "../dashboard/Part&Inventory/Table.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  name: "Parts",
  components: {
    btnPDF,
    btnExportXLSX,
    btnImportXLSX,
    btnBulkActions,
    btnPartSetting,
    btnBulkOrderPos,
    btnAddPart,
    btnAddStock,
    Chart,
    Table,
  },

  data() {
    return {
      sortBy: "Price",
      sortDesc: false,
      select1: [],
      colbtn: false,
      selectFilterName: "",
      selectFilterAsset: "",
      selectFilterCategory: "",
      selectFilterLocation: "",
      selectFilterPOs: "",
      selectFilterPartName: "",
      selectFilterPartNumber: "",
      selectFilterPrice: "",
      selectFilterQty: "",
      selectFilterVendor: "",
      sumpart: 0,
      sumprice: 0,
      searchHeader: [],
      tabs: false,
      searchQuery: null,
      viewerdata: {},
      viewerdata1: {},
      dessert: [],
      locationList: [],
      dangerName: false,
      dangerCate: false,
      dangerNumber: false,
      dangerPOs: false,
      dangerNametext: "",
      dangerCatetext: "",
      dangerNumbertext: "",
      dangerPOstext: "",
      ReportHead: [
        { key: "Task_Name", id: 1, sortable: true },
        { key: "Qty_Used", id: 2, sortable: true },
        { key: "Used_On", id: 3, sortable: true },
        { key: "Used_By", id: 4, sortable: true },
      ],
      ReportList: [
        {
          Task_Name:
            "ใบบันทึกงานซ่อมหวี 1 - #47912 - เปลือกลูกหีบ, Top,ชุด 5, ราง B",
          Qty_Used: 1,
          Used_On: "2021/06/02",
          Used_By: "Delete User",
        },
      ],
      workorders: [],
      rq: 0,
      ap: 0,
      rj: 0,
      rt: 0,
      Requested: [],
      Approve: [],
      Reject: [],
      Return: [],
      tasksstatus: 0,
      logsheader: [
        { key: "workorder_id", sortable: true },
        { key: "requester_id", sortable: true },
        { key: "status", sortable: true },
        { key: "timestamp", sortable: true },
      ],
      PartsLogs: [],
      WorkOderLogs: [],
      WRParts: [],
      Vendor: [
        {
          Name: "Bohler",
          id: 1,
        },
        {
          Name: "RS2",
          id: 2,
        },
      ],
      header2: [
        "Name",
        "Asset",
        "Category",
        "Location",
        "Part Name",
        "Part Number",
        "Price",
        "Qty",
        "Vendor",
      ],
      headers: [
        { key: "Actions", id: "Actions", visible: true },
        { key: "name", id: "Name", sortable: true, visible: true },
        { key: "asset", id: "Asset", sortable: true, visible: true },
        { key: "category", id: "Category", sortable: true, visible: true },
        { key: "location_name", id: "Location", sortable: true, visible: true },
        { key: "partname", id: "Part Name", sortable: true, visible: true },
        { key: "partnumber", id: "Part number", sortable: true, visible: true },
        { key: "price", id: "Price", sortable: true, visible: true },
        { key: "qtycurrent", id: "Qty", sortable: true, visible: true },
        { key: "vendor", id: "Vendor", sortable: true, visible: true },
      ],
    };
  },
  created() {
    this.getWoRequestPart();
    this.select1 = this.headers.map((e) => e.id);
    this.$API.get("parts").then((res) => {
      this.dessert = res.data.result;
      this.Calculate(this.dessert);
    });
    this.$API.get("users/location").then((res) => {
      this.locationList = res.data;
    });
  },
  computed: {
    visibleFields(value) {
      return this.headers.filter((header) => header.visible);
    },
    Fileter() {
      return this.dessert.filter((item) => {
        return (
          item.name
            .toLowerCase()
            .includes(this.selectFilterName.toLowerCase()) &&
          // item.asset
          //   .toString()
          //   .toLowerCase()
          //   .includes(this.selectFilterAsset.toLowerCase()) &&
          item.category
            .toLowerCase()
            .includes(this.selectFilterCategory.toLowerCase()) &&
          item.location_name
            .toLowerCase()
            .includes(this.selectFilterLocation.toLowerCase()) &&
          item.partname
            .toLowerCase()
            .includes(this.selectFilterPartName.toLowerCase()) &&
          item.partnumber
            .toLowerCase()
            .includes(this.selectFilterPartNumber.toLowerCase()) &&
          item.price
            .toLowerCase()
            .includes(this.selectFilterPrice.toLowerCase()) &&
          item.qtycurrent
            .toString()
            .toLowerCase()
            .includes(this.selectFilterQty.toLowerCase()) &&
          item.vendor
            .toLowerCase()
            .includes(this.selectFilterVendor.toLowerCase())
        );
      });
    },
  },

  methods: {
    getWOList(id) {
      this.$API.get(`parts/${id}/workorder`).then((res) => {
        console.log(res.data, "PWO");
        this.workorders = res.data;
      });
    },
    getWoRequestPart() {
      this.$API.get("parts/request").then((res) => {
        this.WorkOderLogs = res.data;
        this.WRParts = res.data;
      });
      setTimeout(() => {
        this.filterpartlog(this.WorkOderLogs);
      }, 1000);
    },
    getpartlogs() {
      this.$API.get("parts/request/log").then((res) => {
        this.PartsLogs = res.data;
        console.log(this.PartsLogs, "logpartssss");
      });
    },
    TasksPopUp(check) {
      if (check == "Requested") {
        this.tasksstatus = 1;
      } else if (check == "Approve") {
        this.tasksstatus = 2;
      } else if (check == "Reject") {
        this.tasksstatus = 3;
      } else if (check == "Return") {
        this.tasksstatus = 4;
      }
      this.$bvModal.show("PartLogs");
    },
    filterpartlog(data) {
      data.forEach((e) => {
        if (e.status === "Requested") {
          this.Requested.push(e);
          this.rq++;
        } else if (e.status === "Approved") {
          this.Approve.push(e);
          this.ap++;
        } else if (e.status === "Rejected") {
          this.Reject.push(e);
          this.rj++;
        } else if (e.status === "Return") {
          this.Return.push(e);
          this.rt++;
        }
      });
    },
    WorkOrderdetail() {
      console.log("workOrder");
    },
    ExportPDF() {
      var w = document.getElementById("content").offsetWidth;
      var h = document.getElementById("content").offsetHeight;
      const doc = new jsPDF("L", "px", [w, h]);
      html2canvas(document.getElementById("content"), {
        width: doc.internal.pageSize.getWidth(),
        height: doc.internal.pageSize.getHeight(),
      }).then((canvas) => {
        const img = canvas.toDataURL("image/png");
        doc.addImage(
          img,
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
        doc.save("Part_ Report.pdf");
      });
    },

    Calculate(amout) {
      amout.forEach((dessert) => {
        this.sumpart += dessert.qtycurrent;
        this.sumprice += parseInt(dessert.price * dessert.qtycurrent);
      });
      this.sumpart = this.NumberWithCommas(this.sumpart);
      this.sumprice = this.NumberWithCommas(this.sumprice);
    },
    NumberWithCommas(amout) {
      return amout.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    tb() {
      var i = 0;
    },
    remove(item) {
      this.searchHeader.splice(this.searchHeader.indexOf(item), 1);

      switch (item) {
        case "Name":
          this.selectFilterName = "";
          break;
        case "Asset":
          this.selectFilterAsset = "";
          break;
        case "Categoty":
          this.selectFilterCategory = "";
          break;
        case "Location":
          this.selectFilterLocation = "";
          break;
        case "Open POs":
          this.selectFilterPOs = "";
          break;
        case "Part Name":
          this.selectFilterPartName = "";
          break;
        case "Part Number":
          this.selectFilterPartNumber = "";
          break;
        case "Price":
          this.selectFilterPrice = "";
          break;
        case "Qty":
          this.selectFilterQty = "";
          break;
        case "Vendor":
          this.selectFilterVendor = "";
          break;
        default:
          console.log("Try looking up for a hint.");
      }
    },
    Partview(item) {
      this.viewerdata = item.item;
      this.$bvModal.show("PartDetail");
    },
    PartviewCard(item) {
      this.viewerdata = item;
      this.$bvModal.show("PartDetail");
    },
    EditPart(item) {
      this.viewerdata1 = item;
      this.$bvModal.show("EditPart");
    },
    EdiPartData() {
      const part = this.viewerdata1;
      let body = {
        id: this.viewerdata1.id,
        name: part.partname,
        asset: part.asset,
        category: part.category,
        open_pos: part.openpos,
        location_id: part.location,
        parts_name: part.partname,
        parts_number: part.partnumber,
        price: part.price,
        qty: part.qtycurrent,
        vendor: part.vendor,
      };
      this.$API.put("parts/edit", body).then((res) => {
        const data2 = res.data;
      });
      this.$bvModal.hide("EditPart");
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    QrCode(item) {
      this.viewerdata = item;
      this.$bvModal.show("QrCode");
    },
    DeletePart(item) {
      this.viewerdata = item;
      this.$bvModal.show("DeletePart");
    },
    Delete(viewerdata) {
      this.$API.delete("parts/delete/" + viewerdata.id).then((res) => {
        return res;
      });
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    nameValidate(data) {
      if (data.length > 20) {
        this.dangerName = true;
        this.dangerNametext = "Part Name must be less than 20 characters";
      } else if (data == "") {
        this.dangerName = true;
        this.dangerNametext = "Part Name is required";
      } else {
        this.dangerName = false;
      }
    },
    cateValidate(data) {
      if (data.length > 20) {
        this.dangerCate = true;
        this.dangerCatetext = "Category must be less than 20 characters";
      } else if (data == "") {
        this.dangerCate = true;
        this.dangerCatetext = "Category Name is required";
      } else {
        this.dangerCate = false;
      }
    },
    numberValidate(data) {
      if (data.length <= 4) {
        this.dangerNumber = true;
        this.dangerNumbertext = "Part Number must be more than 4 characters";
      } else {
        this.dangerNumber = false;
      }
    },
    posValidate(data) {
      if (data.length > 20) {
        this.dangerPOs = true;
        this.dangerPOstext = "Open POs must be less than 20 characters";
      } else if (data == "") {
        this.dangerPOs = true;
        this.dangerPOstext = "Open POs is required";
      } else {
        this.dangerPOs = false;
      }
    },
  },
};
</script>

<style>
.underline-on-hover:hover {
  text-decoration: underline;
}
.center2 {
  margin: auto;
  width: 50%;
}
</style>
